import moment from 'moment'
import BigNumber from 'bignumber.js'
import { divide, times, minus } from '../../../node_modules/number-precision/build/index'
// import i18n from 'translation/index'
import { openErrorToaster } from 'utils/common-services/toaster.service'
import store from 'redux-store/store'
import { CURRENCIES } from 'utils/constants/index'

export const formatDate = (originalDateString) => {
  const date = new Date(originalDateString)

  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ]
  const day = date.getDate()
  const monthIndex = date.getMonth()
  const year = date.getFullYear()
  const formattedDate = `${day} ${months[monthIndex]} ${year}`
  return formattedDate
}

export const formatTime = (originalDateString) => {
  const date = new Date(originalDateString)

  const hours = date.getHours()
  const minutes = date.getMinutes()

  const ampm = hours >= 12 ? 'PM' : 'AM'
  const formattedHours = hours % 12 || 12 // Convert 0 to 12 for 12 AM

  const formattedTime = `${formattedHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`

  return formattedTime
}

export const formatTime24Hour = (originalDateString) => {
  const date = new Date(originalDateString)

  const hours = date.getHours()
  const minutes = date.getMinutes()

  // Format time in 24-hour format
  const formattedTime = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`

  return formattedTime
}

/**
 * Parses payload object from jwt
 * @param {string} token
 * @returns {Object}
 */
export const getPayloadFromToken = (token) => {
  if (token) {
    return JSON.parse(atob(token.split('.')[1]))
  }
}

/**
 * Generate a random card number between [1,52]
 * @returns {number}
 */
export const randomCardGenerate = () => {
  return Math.floor(Math.random() * 52) + 1
}

/**
 *
 * @param {Number} n
 * @returns {Number} factorial of n
 */
export const factorial = n => {
  let fact = 1
  for (let i = 2; i <= n; i++) {
    fact *= i
  }
  return fact
}

/**
 *
 * @param {Number} n
 * @param {Number} r
 * @returns {Number} combination of n over r
 */
export const combination = (n, r) => {
  if (r > n) {
    return 0
  }
  return factorial(n) / (factorial(r) * factorial(n - r))
}

/**
 *
 * @param {Number} numberOfCoins
 * @param {Number} minimumChosenOutcome
 * @returns {Number} probability of minimum X number of favorable outcomes
 */
export const getCoinOutcomeProbability = (numberOfCoins, minimumChosenOutcome) => {
  const n = numberOfCoins - minimumChosenOutcome
  let sum = 0
  for (let i = 0; i <= n; i++) {
    sum += combination(numberOfCoins, i)
  }
  return sum / 2 ** numberOfCoins
}

/**
 * To calculate flip coin potential win
 * @param {number} betAmount
 * @param {number} numberOfCoins
 * @param {number} minimumChosenOutcome
 * @param {number} houseEdge
 * @returns {number}
 */
export const getFlipCoinPotentialWin = (betAmount, numberOfCoins, minimumChosenOutcome, houseEdge) => {
  const probability = getCoinOutcomeProbability(numberOfCoins, minimumChosenOutcome)
  const odds = (1 / probability) * (1 - houseEdge / 100)
  return +Number((betAmount * odds)).toFixed(2)
}

/**
 *
 * @param {string} s
 * @returns {Number} count of one
 */
export const countOnes = (s) => {
  let count = 0
  for (const i of s) {
    if (i === '1') {
      count++
    }
  }
  return count
}

/**
 *
 * @param  {...Array} a Specify arrays to do cartesian product
 * @returns {Array.<Array.<number[]>>} Returns the cartesian product of given arrays
 */
export const cartesianProductOfArrays = (...a) => a.reduce((a, b) => a.flatMap(d => b.map(e => [d, e].flat())))

export const generateClientSeed = () => {
  const availableChars = '0123456789abcdef'
  let seed = ''
  for (let i = 0; i < 32; i++) {
    seed += availableChars[Math.floor(Math.random() * availableChars.length)]
  }
  return seed
}

/**
 *
 * @param {number} x
 * @returns {string} valid million based comma value in string
 */
export const numberWithCommas = (x) => {
  if (x === null || x === undefined || Number(x) === Number.isNaN) {
    return ''
  }
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

/**
 * Get Random Integer from min to max (both inclusive)
 * @param {*} max
 * @returns
 */
export function getRandomInt (min, max) {
  min = Math.ceil(min)
  max = Math.floor(max + 1)
  return Math.floor(Math.random() * (max - min) + min)
}

export const enforceTwoDecimalPlaces = (e) => {
  const value = e.target.value
  const decimalIndex = value.indexOf('.')

  if (decimalIndex !== -1 && value.length - decimalIndex > 3) {
    e.target.value = value.slice(0, decimalIndex + 3) // Limit to two decimal places
  }
}

export function formatToTwoDecimalPlaces (value) {
  if (value === '') return value // if value is empty return value

  const num = parseFloat(value) // Ensure the input is a number
  if (isNaN(num)) {
    return 0 // Return 0 if input is not a valid number
  }
  // Multiply by 100, round to remove extra decimal places, and divide back by 100
  // return Math.round(num * 100) / 100
  return Number(num.toFixed(2))
}

export const blockInvalidChar = (e) => {
  ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()
  if (!/[\d]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete') {
    event.preventDefault()
  }
}

export const copyToClipboard = (text) => {
  if (window.clipboardData && window.clipboardData.setData) {
    // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
    return window.clipboardData.setData('Text', text)
  }
  if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
    const textarea = document.createElement('textarea')
    textarea.textContent = text
    textarea.style.position = 'fixed' // Prevent scrolling to bottom of page in Microsoft Edge.
    document.body.appendChild(textarea)
    textarea.select()
    try {
      return document.execCommand('copy') // Security exception may be thrown by some browsers.
    } catch (ex) {
      console.warn('Copy to clipboard failed.', ex)
      return false
    } finally {
      document.body.removeChild(textarea)
    }
  }
}

export const formatDateTime = (dateString) => {
  // Create a new Date object from the given date string
  const date = new Date(dateString)

  // Extract hours, minutes, and determine AM/PM
  let hours = date.getUTCHours()
  const minutes = date.getUTCMinutes()
  const ampm = hours >= 12 ? 'PM' : 'AM'

  // Convert 24-hour format to 12-hour format
  hours = hours % 12
  hours = hours || 12 // If hours equals 0, change it to 12

  // Format minutes to be 2 digits
  const minutesFormatted = minutes < 10 ? '0' + minutes : minutes

  // Extract month, day, and year
  const month = date.getUTCMonth() + 1 // Months are zero-indexed
  const day = date.getUTCDate()
  const year = date.getUTCFullYear()

  // Return formatted string
  return `${hours}:${minutesFormatted} ${ampm}  ${month}/${day}/${year}`
}

export const format24HourTime = (inputDate) => {
  const formattedTime = inputDate ? moment(new Date(inputDate)).format('HH:mm:ss') : ''
  return formattedTime
}
export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]]
  }
  return array
}

export const toUtcTime = (dateObject = moment(), dateFormat = 'DD/MM/YYYY') => {
  return moment.utc(dateObject).format(dateFormat)
}

export const showToastToLogin = () => {
  openErrorToaster({ message: i18n.t('LOGIN_REQUIRED') })
}

export const blockSpaceChar = e => e.key === ' ' && e.preventDefault()

export const getPrecision = (value = 0, precision) => {
  precision = precision ?? store?.getState()?.gameSetting?.currencyPrecision
  const precisionDivide = Math.pow(10, precision)
  const result = divide(Math.trunc(times(value, precisionDivide)), precisionDivide)
  return result || 0
}

export const getNumToStringPrecision = (input = 0, precision, removeTrailingZeros = true) => {
  precision = precision ?? store?.getState()?.gameSetting?.currencyPrecision
  if (typeof input === 'number') {
    const factor = Math.pow(10, precision)
    input = divide(Math.trunc(times(input, factor)), factor)
    input = input.toFixed(precision)
  }

  const str = String(input)

  return str

  // //This regex checks whether the entire string consists only of 0 and/or . characters, and nothing else
  // if (/^[0.]+$/.test(str)) {
  //   // Only zeros and decimal
  //   return str
  // }

  // if (removeTrailingZeros) {
  //   return str.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.$/, '') // Removes only trailing zeros after decimal
  // } else {
  //   return str
  // }
}

export const getNumberPrecision = (
  input = 0,
  precision,
  preservePrecision = false,
  currencyCode
) => {
  if (!precision && currencyCode) {
    precision = CURRENCIES[currencyCode?.toUpperCase()]?.precision ?? 2
  } else {
    precision = precision ?? store?.getState()?.gameSetting?.currencyPrecision ?? 2
  }

  // Convert exponential number safely to string with required precision
  let str
  if (typeof input === 'number' || typeof input === 'string') {
    str = new BigNumber(input).toFixed(precision, BigNumber.ROUND_DOWN)
  } else {
    str = String(input)
  }

  if (preservePrecision) {
    const [int, dec = ''] = str.split('.')
    return int + '.' + dec.padEnd(precision, '0')
  }

  if (/^[0.]+$/.test(str)) return str

  return str.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.$/, '')
}

export const calculateOdds = ({ minOdds = 0, maxOdds = 0, houseEdge = 0, odds = 0, precision = 2 }) => {
  const deductHouseEdge = minus(1, divide(houseEdge, 100))
  let newOdds = times(odds, deductHouseEdge)
  if (maxOdds) {
    newOdds = Math.min(maxOdds, newOdds) // max odd capping
  }
  if (minOdds) {
    newOdds = Math.max(minOdds, newOdds) // min odd capping
  }
  newOdds = getPrecision(newOdds, precision)
  return newOdds
}

export const validateCrashGameBet = ({
  betAmount,
  minBetData,
  maxBetData,
  balance,
  currencyCode,
  autoRate,
  minAutoRate,
  t
}) => {
  if (isNaN(betAmount)) {
    return { betError: t('isRequired', { label: t('betAmount') }) }
  }

  if (betAmount > balance) {
    return { betError: t('noBalance') }
  }

  if (betAmount > maxBetData) {
    return {
      betError: `${t('maxBetAmount')} ${maxBetData} ${currencyCode} ${t('limit')}`
    }
  }

  if (betAmount < minBetData) {
    return {
      betError: `${t('minBetAmount')} ${Number(minBetData)?.toFixed(2)} ${currencyCode} ${t('notAchieved')}`
    }
  }

  if (autoRate === '') {
    return { autoRateError: t('noAutoCashout') }
  }

  if (parseFloat(autoRate) < minAutoRate) {
    return {
      autoRateError: `${t('autoRateWarning')} ${minAutoRate?.toFixed(2)}X`
    }
  }

  return {} // No error
}
